import { useContext, useEffect, useRef } from 'react'
import AlertContext from './../context/alert/alertContext'
import { useSnackbar } from 'notistack'

const Alerts = () => {
    const alertContext = useContext(AlertContext)
    const { alerts, clearAlert } = alertContext
    const { enqueueSnackbar } = useSnackbar()
    const processedAlertIds = useRef(new Set())

    useEffect(() => {
        alerts.forEach((alert) => {
            if (!alert?.msg || !alert?.id || processedAlertIds.current.has(alert.id)) return

            processedAlertIds.current.add(alert.id)
            enqueueSnackbar(alert.msg, {
                variant: alert.type,
                anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
            })
            clearAlert(alert.id)
        })
    }, [alerts, enqueueSnackbar, clearAlert])

    // const classes = useStyles();
    // warning error info success
    return null
}

export default Alerts
